import { useEffect, useState, useRef } from 'react';
import {
  TabsGroup,
  TabsWrapper,
  PageHeaderTitle,
  PageHeaderWrapper,
  HeaderSection,
} from 'cdk-radial';
import { StyledContentContainer } from './StyledComponents';
import { useTranslation } from 'react-i18next';
import { TabPanel, PageHeaderNavigationTab } from 'cdk-radial';
import FeatureAccessContainer from './FeatureAccessContainer';
import IPRestrictionMainContainer from './IPRestrictionMainContainer';
import { useFeatureFlag } from '@harnessio/ff-react-client-sdk';
import UniPulseMain from '../UniPulse/UniPulseMain';
import AppLinkAdminContainer from './Containers/AppLinkAdminContainer';

interface TabItem {
  id: string;
  panelId: string;
  renderPanel: any;
  renderTab: any;
}

export const DealerAdminTabs = () => {
  const [tabItems, setTabItems] = useState<TabItem[]>([]);
  const { t } = useTranslation();
  const itemsRef = useRef([]) as any;
  const tabsWrapperRef = useRef();
  const [activeNavigationItemIndex, setActiveNavigationItemIndex] = useState(0);

  const restrictionFlag = useFeatureFlag('ADMIN_IP_RESTRICTION_ACCESS');
  const uniPulseFlag = useFeatureFlag('UNIFY_UI_PULSE');
  const linkFlag = useFeatureFlag('DEALER_UI_LINKS');

  // render tabs
  const renderTabs = () => {
    return tabItems.map((item: any, index: any) => {
      const tabRef = (element: any) => (itemsRef.current[index] = element);
      const isActive = activeNavigationItemIndex === index;
      const handleClick = (event: any) => {
        setActiveNavigationItemIndex(index);
        if (item.onClick) {
          item.onClick(event);
        }
      };
      const handleFocus = (event: any) => {
        if (item.onFocus) {
          item.onFocus(event);
        }
      };
      return item.renderTab({
        'aria-controls': item.panelId,
        'aria-selected': isActive,
        id: item.id,
        isActive,
        dataTestId:item.panelId,
        key: item.id,
        onClick: handleClick,
        onFocus: handleFocus,
        ref: tabRef,
        role: 'tab',
        tabIndex: isActive ? 0 : -1,
      });
    });
  };

  useEffect(() => {
    let tabs: TabItem[] = [];
    tabs.push({
      id: 'dealer-admin-tab-1',
      panelId: 'dealer-admin-panel-1',
      renderPanel: (props: any) => (
        <TabPanel {...props}>
          <FeatureAccessContainer></FeatureAccessContainer>
        </TabPanel>
      ),
      renderTab: (props: any) => (
        <PageHeaderNavigationTab label="Feature Access" {...props} tabIndex={0}/>
      ),
    });
    if (restrictionFlag) {
      tabs.push({
        id: 'dealer-admin-tab-2',
        panelId: 'dealer-admin-panel-2',
        renderPanel: (props: any) => (
          <TabPanel {...props}>
            <IPRestrictionMainContainer></IPRestrictionMainContainer>
          </TabPanel>
        ),
        renderTab: (props: any) => (
          <PageHeaderNavigationTab label="IP Access" {...props} tabIndex={0}/>
        ),
      });
    }
    if (uniPulseFlag) {
    tabs.push({
      id: 'dealer-admin-tab-3',
      panelId: 'dealer-admin-panel-3',
      renderPanel: (props: any) => (
        <TabPanel {...props}>
          <UniPulseMain />
        </TabPanel>
      ),
      renderTab: (props: any) => (
        <PageHeaderNavigationTab label="UNI-Pulse" {...props} tabIndex={0}/>
      ),
    });
    }
    if (linkFlag) {
    tabs.push({
      id: 'dealer-admin-tab-4',
      panelId: 'dealer-admin-panel-4',
      renderPanel: (props: any) => (
        <TabPanel {...props}>
          <AppLinkAdminContainer></AppLinkAdminContainer>
        </TabPanel>
      ),
      renderTab: (props: any) => (
        <PageHeaderNavigationTab label="Links" {...props} tabIndex={0}/>
      ),
    });
  }
    setTabItems(tabs);
  }, [restrictionFlag, uniPulseFlag, linkFlag]);

  return (
    <>
      <HeaderSection>
        <PageHeaderWrapper>
          <PageHeaderTitle>{t('dealer-admin.title')}</PageHeaderTitle>
          <TabsWrapper>
            <TabsGroup
              label={'Label that describes the purpose of the set of tabs'}
              ref={(element: any) => (tabsWrapperRef.current = element)}
              role="tablist"
            >
              {renderTabs()}
            </TabsGroup>
          </TabsWrapper>
        </PageHeaderWrapper>
      </HeaderSection>
      <StyledContentContainer>
        {tabItems &&
          tabItems.length > 0 &&
          tabItems[activeNavigationItemIndex].renderPanel({
            'aria-labelledby': tabItems[activeNavigationItemIndex].id,
            id: tabItems[activeNavigationItemIndex].panelId,
            role: 'tabpanel',
          })}
      </StyledContentContainer>
    </>
  );
};
